export interface EventFilterInterface {
    selectedCheckboxes?: string[];
    onHeadersEventFilterClick(selected?: (string | number)[], selectedDate?, dateFrom?, dateTo?): void;
    /**dropdown options  */
    options?: any;
    eventFiltersType?: EventsFiltersTypeEnum;
    timeRangeValue?: string | number;
}

export interface CustomPopoverBodyInterface {
    isLoading?: boolean;
    element: { count: number; label: string; value: string; isEmpty?: boolean };
}

export enum EventsFiltersTypeEnum {
    InProgress,
    All,
}
